<div *ngIf="questionPagesResource != null" id="mrasInterviewForm">
    <div class="container p-4">
        <div class="mb-3 pl-2" *ngFor="let section of sections">
            <div *ngFor="let question of bqToSection.get(section.code); let idx = index" [ngSwitch]="question.questionType">
                <div class="question-container">
                    <div [ngClass]="question.invalid ? 'invalid-question':''">
                        <jhi-question-heading *ngSwitchCase="QuestionType.HEADING"
                                            [questionIdentifier]="questionIdentifier(question)"
                                            [(question)]="bqToSection.get(section.code)[idx]"
                                            [summaryMode]="summaryMode">
                        </jhi-question-heading>
                        <jhi-question-standard *ngSwitchCase="QuestionType.STANDARD"
                                            [questionIdentifier]="questionIdentifier(question)"
                                            [(question)]="bqToSection.get(section.code)[idx]"
                                            (questionChange) = "updateQuestionProgress()"
                                            [caseDetails]="caseDetails"
                                            [(disclosures)]="questionPagesResource._embedded[EmbeddableResourceNames.DISCLOSURES]"
                                            [(physicians)]="questionPagesResource._embedded[EmbeddableResourceNames.PHYSICIANS]"
                                            [(disclosurePhysicians)]="questionPagesResource._embedded[EmbeddableResourceNames.DISCLOSURE_PHYSICIANS]"
                                            [countries]="countries"
                                            [summaryMode]="summaryMode">
                        </jhi-question-standard>
                        <jhi-question-conditional *ngSwitchCase="QuestionType.CONDITIONAL"
                                                [questionIdentifier]="questionIdentifier(question)"
                                                [question]="bqToSection.get(section.code)[idx]"
                                                (questionChange) = "updateQuestionProgress()"
                                                [(disclosures)]="questionPagesResource._embedded[EmbeddableResourceNames.DISCLOSURES]"
                                                (onQuestionChange)="handleQuestionChange($event)"                                          
                                                [summaryMode]="summaryMode">
                        </jhi-question-conditional>
                        <jhi-question-case-data
                            *ngSwitchCase="QuestionType.CASE_DATA"
                            [questionIdentifier]="questionIdentifier(question)"
                            [(embedded)]="questionPagesResource._embedded"
                            [question]="bqToSection.get(section.code)[idx]"
                            (onQuestionChange)="handleQuestionChange($event); updateQuestionProgress();"
                            [summaryMode]="summaryMode">
                        </jhi-question-case-data>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
